import React from "react";
import { Route } from "react-router-dom";
import WorkerSignIn from "../components/worker_signin";
import ForgotPassword from "../components/worker_forgot_password";
import ResetPassword from "../components/worker_reset_password";

const SignInRoutes = () => {
  return (
    <>
      <Route path="/signin" element={<WorkerSignIn />} /> 
      <Route path="/forgot-password" element={<ForgotPassword />} /> 
      <Route path="/reset-password/" element={<ResetPassword />} /> 
    </>
  );
};

export default SignInRoutes;
